import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingCartIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/links";
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const anchor = document.getElementById("first-cta");
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().top < 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return <AnimatePresence data-id="element-33" data-mp="2ft3bmpvzfid7">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 sm:bottom-5 sm:left-auto sm:right-5 sm:px-0 sm:pb-0" data-id="element-34" data-mp="2avl3v2tpb96s">
          <a href={CHECKOUT_URL} className="animate-cta-shake flex w-full items-center justify-center gap-2 rounded-2xl bg-cta px-6 py-4 text-ink shadow-[0_6px_0_0_#15803D,0_16px_40px_-6px_rgba(0,0,0,0.6)] focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/60 sm:w-auto" data-id="element-35" data-mp="2z30l59usf402">
            <ShoppingCartIcon className="h-5 w-5 shrink-0" strokeWidth={2.5} aria-hidden="true" data-id="element-36" data-mp="2u9o8ly3dunno" />
            <span className="whitespace-nowrap text-base font-black uppercase" data-id="element-37" data-mp="2fcf380h8vjcy">Get it now — only $27</span>
          </a>
        </motion.div>}
    </AnimatePresence>;
}